import React from 'react';
import { displayDate } from '../utils/dates';

export default function EntryListView({ entries, dates, onEntryClick }) {
  // Group entries by date
  const grouped = {};
  for (const date of dates) {
    grouped[date] = entries.filter((e) => e.EntryDate?.split('T')[0] === date);
  }

  const datesWithEntries = dates.filter((d) => grouped[d].length > 0);

  if (datesWithEntries.length === 0) {
    return (
      <div className="empty-state">
        <p>No time entries yet for this period.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '0 0 20px' }}>
      {datesWithEntries.map((date) => {
        const dayEntries = grouped[date];
        const dayTotal = dayEntries.reduce((s, e) => s + (parseFloat(e.Hours) || 0), 0);
        const missingDesc = dayEntries.some((e) => !e.Description);
        let badgeClass = 'daily-total';
        if (dayTotal > 24) badgeClass += ' over-limit';
        else if (missingDesc) badgeClass += ' warn-desc';
        else if (dayTotal > 8) badgeClass += ' over';
        else if (dayTotal === 8) badgeClass += ' full';
        else badgeClass += ' partial';

        return (
          <div key={date} className="card">
            <div className="card-header">
              <span className="card-title">{displayDate(date, { weekday: true })}</span>
              <span
                className={badgeClass}
                style={{ fontSize: '13px', padding: '4px 10px' }}
              >
                {dayTotal.toFixed(2)} hrs
                {dayTotal > 24 ? ' (over 24)' : dayTotal > 8 ? ' (over 8)' : ''}
                {missingDesc && dayTotal <= 24 ? ' *' : ''}
              </span>
            </div>
            {dayEntries.map((entry) => (
              <div key={entry.TimeEntryID} style={{
                padding: '8px 0',
                borderBottom: '1px solid var(--gray-100)',
                fontSize: '14px',
                cursor: onEntryClick ? 'pointer' : 'default',
              }}
                onClick={onEntryClick ? () => onEntryClick(entry.JobID, entry.JobTaskID, entry.EntryDate?.split('T')[0]) : undefined}
              >
                <div style={{ fontWeight: 500 }}>
                  {entry.JobID} - {entry.JobName} / {entry.JobTaskID} – {entry.TaskCode} – {entry.TaskName}
                </div>
                <div style={{ color: 'var(--gray-500)', fontSize: '13px' }}>
                  {entry.Hours} hrs &middot; {entry.RateCodeName}
                  {entry.Description && ` — ${entry.Description}`}
                </div>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
